import {Component, OnDestroy,NgZone, ChangeDetectorRef, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from '../../../Services/client.service';
import {AuthService} from '../../../auth/AuthService';
import {ActivatedRoute, Router} from '@angular/router';
import {first, map, tap} from 'rxjs/operators';
import swal from 'sweetalert2';
import {jwtDecode} from 'jwt-decode';
import {DatePipe} from '@angular/common';
import {UserService} from '../../../Services/UserService';
import {ProviderService} from '../../../Services/provider.service';
import {statesDropdown} from '../../../shared/StatesUS';

@Component({
    selector: 'pm-create-user',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit,OnDestroy {
    uCreationForm!: FormGroup;
    clientRoleData: any= []; // Holds the API response
    clientArray: string[] = []; // Array for client IDs
    roleArray: any[] = []; // Array for roles based on selected client ID
    userId: any;
    userType: any;
    status: any;
    today = new Date();
    showUserName = false;
    checkbox: boolean = false;
    hidePassword = true;
    isProvider: boolean = false;
    userTypeArray: any = [
        {value: 'EXTERNAL', viewValue: 'External'},
        {value: 'INTERNAL', viewValue: 'Internal'},
    ];

    groupArray: any = []

    /*typeArray: any = [
        {value: 'admin', viewValue: 'Admin'},
        {value: 'supervisor', viewValue: 'Supervisor'},
        {value: 'team-member', viewValue: 'Team-Member'},
        {value: 'auditor', viewValue: 'Auditor'},
    ];*/

    totalRoles = [
     /*   {value: 'master-admin', viewValue: 'master-admin'},
        {value: 'client-view', viewValue: 'client-view'},
        {value: 'client-edit', viewValue: 'client-edit'},
        {value: 'user-view', viewValue: 'user-view'},
        {value: 'user-edit', viewValue: 'user-edit'},
        {value: 'patient-view', viewValue: 'patient-view'},
        {value: 'patient-edit', viewValue: 'patient-edit'},
        {value: 'report-view', viewValue: 'report-view'},
        {value: 'report-edit', viewValue: 'report-edit'},*/
    ]

    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];

    stateList:any = statesDropdown

    // clientRoleArray: any = [];
    cRoleFilteredList: any = [];
    clientList: any = [];
    OfficeType: any = [];
    parentClientId:any = []

    providerId: any = null;
    staffId: any = null;
    staffType: any = null;
    staffFormData: any = null;

    constructor(private fb: FormBuilder,
                private userServices: UserService,
                private clientServices: ClientService,
                private providerServices: ProviderService,
                private authService: AuthService,
                private activatedRoute: ActivatedRoute,
                private route: Router,
                private datePipe: DatePipe,
                private ngZone: NgZone,
                private cdRef: ChangeDetectorRef) {


        this.userId = this.activatedRoute.snapshot.paramMap.get('id');



        // Retrieve JWT token and extract clientId
        this.authService.getAccessToken().then((token) => {
            if (token) {
                const decodedToken: any = jwtDecode(token);
                this.userType = decodedToken.userType; // Extract clientId from JWT
                // Now you can use this.clientId wherever needed, e.g., in API calls
                if (this.userType == 'INTERNAL') {
                    this.getRequiredList();
                    this.setValidator();
                }

            }
        }).catch(error => {
            console.error('Error fetching JWT token:', error);
        });
        

        const storedClientId = localStorage.getItem('clientId');
        this.uCreationForm = this.fb.group({
            id: [],
            firstName: [null, Validators.required],
            lastName: [null, Validators.required],
            dob: [null, Validators.required],
            gender: [null, Validators.required],
            userName: [null, Validators.required],
            password: [null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
            temporary: [{value: false, disabled: true}],
            userType: ['EXTERNAL'],
            clientIds: [
                storedClientId
                    ? [JSON.parse(storedClientId)]
                    : []
            ],
            group:[null],
            roles:[[null]],

            //rolesClientId: [[], Validators.required],
            //clientRoles: [[], Validators.required],
            department: [null, Validators.required],
            email: [null, [Validators.required, Validators.email]],
        });

    }


    ngOnInit(): void {
        this.getGroup();
        if (this.userId) {
            this.uCreationForm.get('password')?.clearValidators();
            this.uCreationForm.get('password')?.updateValueAndValidity();

            const reqData = { userId: this.userId };

        this.userServices.getUserDetails(reqData).pipe(first()).subscribe(
            (response: any) => {
                if (response) {
                    const userData = response;
                    this.status = userData.active;

                    const userRoles =
                        userData.roleGroup?.role?.map(
                            (role: any) => role.name
                        ) || [];

                    this.ngZone.run(() => {

                        this.uCreationForm.patchValue({
                            firstName: userData.firstName,
                            lastName: userData.lastName,
                            dob: userData.dob
                                ? new Date(userData.dob)
                                : null,
                            userName: userData.userName,
                            email: userData.contact?.email,
                            gender: userData.gender,
                            department: userData.department?.deptName,

                            clientIds: userData.clientIds || [],

                            userType: userData?.userType
                                ? userData.userType
                                : 'EXTERNAL',

                            group: userData.roleGroup?.groupName,

                            roles: userRoles
                        }, {
                            emitEvent: false
                        });

                        this.uCreationForm.markAsPristine();

                        this.cdRef.detectChanges();
                    });

                    this.getGroupRoles(
                        userData.roleGroup?.groupName
                    );
                }
            },
            (error: any) =>
                this.showError(error?.error?.message)
        );
        }
        // Subscribe to changes in the password field
        this.uCreationForm.get('password')?.valueChanges.subscribe((value) => {
            if (value && this.uCreationForm.controls.password.valid) {
                this.uCreationForm.get('temporary')?.enable();
            } else {
                // If password is removed, uncheck and disable the temporary checkbox
                this.uCreationForm.get('temporary')?.setValue(false);
                this.uCreationForm.get('temporary')?.disable();
            }
        });

        this.providerServices.userData.subscribe((data: any) => {
            if (data) {
                if (data.providerIsUser || data.staffIsUser) {
                    this.staffFormData = data;
                    // console.log('Data received in subscription:', data);
                    // Check if StaffType is provider
                    this.isProvider = data.staffType === 'PROVIDER';
                    this.providerId = data?.providerId;
                    this.staffId = data?.staffId;
                    this.staffType = data?.staffType;
                    // Patch data into the form from provider
                    this.uCreationForm.patchValue({
                        firstName: data?.firstName ? data.firstName : null,
                        lastName: data?.lastName ? data.lastName : null,
                        dob: data?.dob ? new Date(data.dob) : null, // Assuming dob is part of data
                        userName: data?.userName ? data.userName : null,
                        email: data?.contact?.email ? data.contact?.email : null,
                        gender: data?.gender ? data.gender : null,
                        department: data?.department ? data.department : null,
                        clientIds: data?.clientIds ? data.clientIds : null,
                        userType: data?.userType ? data.userType : 'EXTERNAL',
                    });
                }
            } else {
                // console.log('No data received to patch into form.');
            }
        });
    }


    getGroup(): void {
        const params = { type: 'group' };
        this.clientServices.getGroup(params).pipe(first()).subscribe(
            (response: any) => {
                if (response?.data) {
                    this.groupArray = response.data;
                }
            },
            (error) => this.showError('Failed to fetch groups.')
        );
    }

    // Modified to handle both edit and group change scenarios
    getGroupRoles(groupName: string): void {
        if (!groupName) {
            return;
        }

        const params = {
            type: 'realm'
        };

        this.clientServices
            .getClientRoles(params)
            .pipe(first())
            .subscribe(
                (response: any) => {

                    if (response?.data) {

                        this.ngZone.run(() => {

                            this.totalRoles = response.data;

                            this.cdRef.detectChanges();

                            this.getGroupSpecificRoles(groupName);
                        });
                    }

                },
                (error: any) =>
                    this.showError('Failed to fetch roles.')
            );
    }

    // New method to handle group-specific roles
    private getGroupSpecificRoles(groupName: string): void {

        const params = {
            groupName
        };

        this.clientServices
            .getClientRoles(params)
            .pipe(first())
            .subscribe(
                (response: any) => {

                    if (response?.data) {

                        const groupRoles = response.data.map(
                            (item: any) => item.realmName
                        );

                        this.ngZone.run(() => {

                            const groupControl =
                                this.uCreationForm.get('group');

                            if (
                                !this.userId ||
                                groupControl?.dirty
                            ) {

                                this.uCreationForm.patchValue(
                                    {
                                        roles: groupRoles
                                    },
                                    {
                                        emitEvent: false
                                    }
                                );
                            }

                            this.cdRef.detectChanges();
                        });
                    }
                },
                (error: any) =>
                    this.showError(
                        'Failed to fetch group roles.'
                    )
            );
    }

    filterAndMergeRoles(groupRoles: string[]): string[] {
        // Get currently selected roles from the form
        const existingRoles = this.uCreationForm.controls.roles.value || [];

        // Filter totalRoles to include only roles specific to the selected group
        const filteredRoles = this.totalRoles
            .filter((role: any) => groupRoles.includes(role.realmName))
            .map((role: any) => role.realmName);

        // Merge and remove duplicates
        return Array.from(new Set([...existingRoles, ...filteredRoles]));
    }



    private showError(message: string): void {
        swal.fire({
            title: 'Error!',
            icon: 'error',
            text: message,
            showConfirmButton: false,
            timer: 5000,
        });
    }

    togglePasswordVisibility() {
        this.hidePassword = !this.hidePassword;
    }

    show(event: any) {
        if (this.uCreationForm.controls.password.value !== null && event.checked == true) {
            this.uCreationForm.controls.temporary.setValue(true);
        } else {
            this.uCreationForm.controls.temporary.setValue(false);
        }
    }

    setValidator() {
    const userTypeControl = this.uCreationForm.get('userType');
    const clientIdsControl = this.uCreationForm.get('clientIds');

    if (this.userType === 'external') {
        userTypeControl?.setValidators([Validators.required]);
        userTypeControl?.markAsUntouched();

        clientIdsControl?.setValidators([Validators.required]);
        clientIdsControl?.markAsUntouched();
    } else {
        userTypeControl?.clearValidators();
        clientIdsControl?.clearValidators();
    }

    userTypeControl?.updateValueAndValidity();
    clientIdsControl?.updateValueAndValidity();
    }

    getRequiredList(): void {

        this.clientServices
            .getClientDetails()
            .pipe(first())
            .subscribe(
                (response: any) => {

                    if (response) {

                        this.ngZone.run(() => {

                            this.clientList = response;

                            const selectedClientIds =
                                this.uCreationForm
                                    .get('clientIds')
                                    ?.value || [];

                            this.uCreationForm
                                .get('clientIds')
                                ?.setValue(
                                    [...selectedClientIds],
                                    {
                                        emitEvent: false
                                    }
                                );

                            this.cdRef.detectChanges();
                        });
                    }
                }
            );
    }

    // set username as email
    setUsernameAsEmail(): void {
        this.uCreationForm.controls.userName.setValue(
            this.uCreationForm.controls.email.value
        );
    }


    // Change status
    changeStatus(status: any) {
        this.status = !status;
    }


    // Remove null properties when submitting the form
    private removeNullProperties(obj: any): any {
        return Object.keys(obj)
            .filter((key) => obj[key] !== null && obj[key] !== undefined)
            .reduce((acc: { [key: string]: any }, key: string) => {

                if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {

                    const nestedObj = this.removeNullProperties(obj[key]);

                    if (Object.keys(nestedObj).length > 0) {
                        acc[key] = nestedObj;
                    }

                } else {
                    acc[key] = obj[key];
                }

                return acc;

            }, {});
    }

    // Register client function / update
    onRegister(): any {
        this.uCreationForm.markAllAsTouched();
        if (this.uCreationForm.valid) {
            const reqData: any = {
                clientIds: this.uCreationForm.controls.clientIds.value || null,
                userType: this.uCreationForm.controls.userType.value || null,
                userName: this.uCreationForm.controls.userName.value || null,
                firstName: this.uCreationForm.controls.firstName.value || null,
                lastName: this.uCreationForm.controls.lastName.value || null,
                dob: this.uCreationForm.controls.dob.value
                    ? this.datePipe.transform(this.uCreationForm.controls.dob.value, 'MM-dd-yyyy')
                    : null,
                gender: this.uCreationForm.controls.gender.value || null,

                roleGroup:{
                    groupName:this.uCreationForm.controls.group.value || null,
                    role: this.uCreationForm.controls.roles.value?.map((role: string) => ({
                        name: role
                    })) || []
                },
                department: {
                    deptName: this.uCreationForm.controls.department.value || null,
                },
            };

            // Conditionally add password and temporary fields if `userId` is not present
            if (!this.userId) {
                reqData.password = this.uCreationForm.controls.password.value || null;
                reqData.temporary = this.uCreationForm.controls.temporary.value || false;
            }
            if (this.staffFormData?.staffId) {
                reqData.staffId = this.staffFormData.staffId || null;
            }
            if (this.staffFormData?.providerId) {
                reqData.providerId = this.staffFormData.providerId || null;
            }
            if (this.staffType) {
                reqData.staffType = this.staffFormData.staffType || null;
            }
            // User email is still required
            reqData.contact = {
                email: this.uCreationForm.controls.email.value || null
            };

            // if (this.staffId || this.providerId) {
            //     reqData.contact = this.staffFormData.contact;
            // } else {
            //     reqData.contact = {email: this.uCreationForm.controls.email.value || null,};
            // }
            // if (this.staffFormData?.address) {
            //     reqData.address = this.staffFormData.address;
            // }
            // if (this.staffFormData?.office) {
            //     reqData.office = this.staffFormData.office;
            // }
            // if (this.staffFormData?.salutation) {
            //     reqData.salutation = this.staffFormData.salutation;
            // }

            // Remove null properties
            const sanitizedData = this.removeNullProperties(reqData);

            // update logic
            if (this.userId) {
                let params = {
                    userId: this.userId,
                };
                this.userServices.updateUser(sanitizedData, params).pipe(first()).subscribe(
                    (response: any) => {
                        if (response != undefined) {
                            this.route.navigate(['user']);
                            swal.fire({
                                icon: 'success',
                                text: 'User :- ' + `" ${sanitizedData.firstName} "` + ' updated successfully.',
                                showConfirmButton: false,
                                timer: 3000
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: response?.message ? response?.message : 'something went wrong',
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                );
            }
            // add / register logic
            else {
                this.userServices.createUser(sanitizedData).pipe(first()).subscribe(
                    (response: any) => {
                        if (response != undefined) {
                            this.route.navigate(['user']);
                            swal.fire({
                                icon: 'success',
                                text: 'User :- ' + `" ${sanitizedData.firstName} "` + ' created successfully.',
                                showConfirmButton: false,
                                timer: 3000
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: response?.message ? response?.message : 'something went wrong',
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                );
            }

        }
    }
    ngOnDestroy(): void {
        this.providerServices.userData.next(null);
    }

}
